import React, {useState} from 'react';
import {
    Box,
    Tab,
    Tabs,
    useTheme,
    useMediaQuery,
    tabsClasses,
} from '@mui/material';

import {
    AddLink,
    LinkOff,
    List,
    RadioButtonChecked,
    SyncAlt,
    ViewDay,
    ZoomInMap,
} from '@mui/icons-material';

import PermissionGuard from '../../contexts/PermissionContext';

import ControlBar from '../structure/ControlBar';
import ControlButton from '../structure/ControlButton';
import ControlDivider from '../structure/ControlDivider';
import SmallKeyValue from '../display/SmallKeyValue';
import BaseMenu from '../rightclicks/BaseMenu';


export default function LinkViewMenuBarDesktop(props) {

    const {
        autoLinkShots,
        sources,
        selectedSource,
        runPrintTakes,
        showAllShots,
        showUnlinkedShots,
        allShotRows,
        selectedShots,
        selectedMetadata,
        linkMetadataToShot,
        unlinkMetadataFromShot,
        sourceIndex,
        handleSourceChange,
        sourceTabs
    } = props;

    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.down('sm'))
    const isSm = useMediaQuery(theme.breakpoints.down('md'))
    const isMd = useMediaQuery(theme.breakpoints.down('lg'))

    const [moreMenuAnchorEl, setMoreMenuAnchorEl] = useState(null)

    const handleMoreMenuClick = (event) => {
        setMoreMenuAnchorEl(event.currentTarget)
    }

    const handleMoreMenuClose = () => {
        setMoreMenuAnchorEl(null)
    }

    return (
        <React.Fragment>
            <ControlBar display='flex'>
                <Box display='flex' alignItems="center">
                {
                    isXs
                    ?
                    <></>
                    :
                    <React.Fragment>
                        <PermissionGuard permission={['update:media', 'read:metadata']}>
                            <ControlButton 
                                title="Autolink metadata" 
                                clicked={autoLinkShots}>
                                <SyncAlt />
                            </ControlButton>
                            <div id='linking-view-print-takes'>
                            <ControlButton
                                disabled={Object.keys(sources).indexOf(selectedSource) !== -1 && Object.keys(sources[selectedSource]).indexOf('type') !== -1 && sources[selectedSource]['type'] === "script" ? false : true}
                                title="Run Print Takes"
                                clicked={runPrintTakes}>
                                <RadioButtonChecked  />
                            </ControlButton>
                            </div>
                            <ControlDivider />
                        </PermissionGuard>
                        <PermissionGuard permission={['read:metadata']}>
                            <div id='linking-view-shots-filter' style={{ display: 'flex' }}>
                            <ControlButton 
                                title="Show all shots"
                                clicked={showAllShots}>
                                <ViewDay  />
                            </ControlButton>
                            <ControlButton 
                                title="Only unlinked shots"
                                clicked={showUnlinkedShots}>
                                <ZoomInMap  />
                            </ControlButton>
                            </div>
                        </PermissionGuard>
                    </React.Fragment>             
                }
                <PermissionGuard permission={['update:media', 'read:metadata']}>
                    <ControlDivider />
                    <Box
                        display='flex'
                        flexDirection='row'
                        alignItems='center'
                    >
                        <div 
                        id='linking-view-select-shot-metadata' 
                        style={{ 
                            display: 'flex',
                        }}
                        >
                            <Box 
                                width={isSm ? '60px' : '120px'}
                            >
                            <SmallKeyValue 
                                    keyLabel="Shot" 
                                    value={
                                        selectedShots.length > 1 ? '(Multiple shots)'
                                        : selectedShots.length === 1 ? allShotRows[selectedShots]['clipname']
                                        : '--'
                                    }
                                    highlighted={ selectedShots.length !== 0 }
                                />
                            </Box>
                            <Box 
                                width={isSm ? '60px' : '120px'}
                            >
                                <SmallKeyValue 
                                    keyLabel="Metadata ID" 
                                    value={selectedMetadata.length > 0 ? selectedMetadata : '--'}
                                    highlighted={ selectedMetadata.length !== 0 }
                                /> 
                            </Box>
                        </div>
                        {
                            isXs
                            ?
                            <></>
                            :
                            <React.Fragment>
                                <ControlDivider />
                                <div id='linking-view-link-button'>
                                    <ControlButton 
                                        disabled={selectedShots === "--" || selectedMetadata === "--" ? true : false}
                                        title="Link Metadata to Shot(s)"
                                        clicked={linkMetadataToShot}  
                                    >
                                        <AddLink  />
                                    </ControlButton>
                                </div>

                                    <div id='linking-view-unlink-button'>
                                    <ControlButton 
                                        disabled={selectedShots === "--" ? true : false}
                                        title={`Unlink ${selectedSource} from shot(s)`}
                                        clicked={unlinkMetadataFromShot}>
                                        <LinkOff  />
                                    </ControlButton>
                                </div>
                            </React.Fragment>

                        }
                    </Box>
                </PermissionGuard>
                </Box>
                <PermissionGuard permission={['read:metadata']}>
                <ControlDivider />
                {
                    isXs || isSm
                    ?
                        <React.Fragment>

                            <ControlButton
                            title="More"
                            clicked={handleMoreMenuClick}
                            >
                                <List  style={{ fill: "white" }} />
                            </ControlButton>
                        </React.Fragment>
                        :
                        <Box sx={{
                            minWidth: '20vw'
                        }}>
                            <Tabs
                                value={sourceIndex}
                                onChange={handleSourceChange}
                                indicatorColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                                allowScrollButtonsMobile
                                sx={{
                                    [`& .${tabsClasses.scrollButtons}`]: {
                                        '&.Mui-disabled': { opacity: 0.2 },
                                    },
                                }}>
                                {sourceTabs.map((tab, index) => (
                                    <Tab
                                        key={index}
                                        label={tab}
                                        sx={{
                                            minWidth: 'auto',
                                            margin: 0,
                                            textTransform: 'none',
                                            color: 'white',
                                            '&.Mui-selected': {
                                                color: 'rgb(73, 200, 255)', 
                                            }
                                        }}
                                    />
                                ))}
                            </Tabs>
                        </Box>
                }
                </PermissionGuard>

                <BaseMenu
                    handleMenuClose={handleMoreMenuClose}
                    menuAnchorEl={moreMenuAnchorEl}
                >
                    <Box
                        id='explore-view-generate-cdl'
                    >          
                        <Tabs
                            value={sourceIndex}
                            onChange={handleSourceChange}
                            indicatorColor="primary"
                            variant="scrollable"
                            scrollButtons="auto"
                            allowScrollButtonsMobile
                            sx={{
                                [`& .${tabsClasses.scrollButtons}`]: {
                                    '&.Mui-disabled': { opacity: 0.2 },
                                }                                
                            }}>
                            {sourceTabs.map((tab, index) => (
                                <Tab
                                    key={index}
                                    label={tab}
                                    sx={{
                                        minWidth: 'auto',
                                        margin: 0,
                                        textTransform: 'none',
                                        color: 'white',
                                        '&.Mui-selected': {
                                            color: 'rgb(73, 200, 255)', 
                                        }
                                    }}
                                />
                            ))}
                        </Tabs>
                    </Box>
                </BaseMenu>

            </ControlBar>
        </React.Fragment>
    );
}